import type { QueryClient } from '@tanstack/react-query';

/**
 * Query keys of the dashboard overview (the to-do card). Keyed on brand, so a
 * brand switch reads the other brand's figures rather than showing the cached
 * ones. Kept apart from the query hook so the mutations that change a figure
 * can stale it without importing the request code.
 */
export const dashboardOverviewKeys = {
  all: ['dashboard-overview'] as const,
  brand: (brandId: string) => ['dashboard-overview', brandId] as const,
};

/**
 * Stale the to-do card, every brand at once: a gesture that changes one of its
 * figures (an application decided, a UGC decision taken, a gift moved, a payout
 * launched) only knows its own surface, and the card reads them all.
 */
export const invalidateDashboardOverview = (queryClient: QueryClient): void => {
  void queryClient.invalidateQueries({ queryKey: dashboardOverviewKeys.all });
};
